import { CoachsListType, TownType } from "../Structures";
import { Button } from "../Components/Base";
import { ProfileLayout } from "../Container/Layout";
import { LoadingContext, MainContext, ProfileContext } from "../Context";
import React, { useContext, useEffect, useState } from "react";
import {
  TransactionGetCoachs,
  TransactionUpdateProfile,
} from "../Services/Transactions";
import {
  jalali_to_gregorian,
  textToObject,
  Toast,
} from "../Utils";
import { UserDocuments } from "../Components/Pages";

const MyInformationPage = () => {
  const { profile } = useContext(ProfileContext);
  const { townList } = useContext(MainContext);
  const { setLoading } = useContext(LoadingContext);

  // ================================================================================================

  const [townId, setTownId] = useState<TownType["id"]>(
    profile.coach?.town.id || 0
  );
  const [coachId, setCoachId] = useState<CoachsListType["id"]>(
    profile.coach?.id || 0
  );
  const [coachsList, setCoachsList] = useState<CoachsListType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // ================================================================================================

  function formIsValid() {
    return !!coachId;
  }

  function handleSubmitForm() {
    if (formIsValid()) {
      setIsLoading(true);
      const form = new FormData();

      form.append("first_name", profile.first_name);
      form.append("last_name", profile.last_name);
      form.append("fatherName", profile.fatherName!);
      form.append("gender", profile.gender?.toString()!);
      form.append("city", profile.city!);
      form.append("nationalCode", profile.nationalCode!);
      form.append("coach_id", coachId.toString());
      form.append(
        "birthDay",
        jalali_to_gregorian(
          textToObject(profile.birthDay!).year,
          textToObject(profile.birthDay!).month,
          textToObject(profile.birthDay!).day
        )
      );
      TransactionUpdateProfile(form)
        .then(({ data: res }) => {
          if (res.transaction_status) {
            Toast("success", "مربی شما با موفقیت ثبت شد.");
          } else {
            Toast("error", res.message);
          }
        })
        .finally(() => setIsLoading(false));
    }
  }

  function handleSelectStatus(status: boolean) {
    if (!status) {
      return <i className="bi bi-x-circle-fill text-danger d-flex mx-2 fs-5" />;
    }
    return (
      <i className="bi bi-check-circle-fill text-success d-flex mx-2 fs-5" />
    );
  }

  // ================================================================================================

  useEffect(() => {
    setLoading(true);
    TransactionGetCoachs()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setCoachsList(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setCoachId(profile.coach?.id || 0);
    setTownId(profile.coach?.town.id || 0);
  }, [profile.coach, coachsList]);

  // ================================================================================================

  return (
    <ProfileLayout>
      <div className="col-12">
        <div className="card border mb-4">
          <div className="card-header border-bottom p-3">
            <h4 className="card-header-title mb-0">اطلاعات</h4>
          </div>
          <div className="card-body">
            <div
              className={`d-flex input-group w-100 gap-2 mb-3 ${
                isLoading ? "disabled" : ""
              }`}
            >
              <div className="flex-grow-1 w-25">
                <label className="form-label">استان</label>
                <select
                  onChange={(e) => setTownId(Number(e.target.value))}
                  className="form-select cursor-pointer"
                  value={townId}
                >
                  <option value={0}>انتخاب کنید</option>
                  {townList.map((town) => (
                    <option key={town.id} value={town.id}>
                      {town.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className={`${!townId ? "disabled" : ""}  flex-grow-1 w-25`}>
                <label className="form-label">مربی</label>
                <select
                  onChange={(e) => setCoachId(Number(e.target.value))}
                  className="form-select cursor-pointer"
                  value={coachId}
                >
                  <option value={0}>انتخاب کنید</option>
                  {coachsList
                    .filter((coach) => coach.town.id == townId)
                    .map((coach) => (
                      <option key={coach.id} value={coach.coach_id}>
                        {coach.user.fullname}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <Button
              text="ذخیره"
              onClick={handleSubmitForm}
              isLoading={isLoading}
              disabled={!formIsValid()}
              btnClass="btn w-100 btn-primary"
            />
          </div>
        </div>
        <div className="card border mb-4">
          <div className="card-header border-bottom p-3">
            <h4 className="card-header-title mb-0">وضعیت احراز هویت</h4>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-md-4 d-flex justify-content-center align-items-center">
                {handleSelectStatus(profile.personalVerification)}
                احراز هویت
              </div>
              <div className="col-12 col-md-4 d-flex justify-content-center align-items-center">
                {handleSelectStatus(profile.verified_by_coach)}
                تایید توسط مربی
              </div>
              <div className="col-12 col-md-4 d-flex justify-content-center align-items-center">
                {handleSelectStatus(profile.verified_by_responsible)}
                تایید توسط مسئول احکام
              </div>
            </div>
          </div>
        </div>
        <UserDocuments />
      </div>
    </ProfileLayout>
  );
};

export default MyInformationPage;
